import { render, staticRenderFns } from "./HotelService.vue?vue&type=template&id=5c5d707a&scoped=true"
import script from "./HotelService.vue?vue&type=script&lang=js"
export * from "./HotelService.vue?vue&type=script&lang=js"
import style0 from "./HotelService.vue?vue&type=style&index=0&id=5c5d707a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d707a",
  null
  
)

export default component.exports